import React from 'react'
import { Modal } from 'react-bootstrap'
import youtubeImg from '../../assets/YoutubeOctDenoiserBeauty_001.png'

const YoutubeConcent = ({ show, handleClose }) => {
  return (
    <>
      <Modal show={show} onHide={handleClose} className="youtube-modal" >
        <Modal.Body className="m-2">
          <div className="d-flex justify-content-between mb-4">
            <h4 className="my-auto">Enable <span className="text-danger">YouTube</span> speakers!</h4>
            <img src={youtubeImg} className="img-fluid" alt="youtube icon" />
          </div>
          <b>1.</b> As a learner, your privacy is our supreme priority. None of your sessions will be made public without your express approval. Rest assured.<br /><br />
          <b>2.</b>  This icon signifies the tutor's willingness to allow session recordings uploaded to YouTube. However, written consent from Clapingo is a must. Permission may only be granted to after review.<br /><br/>
          <b>3.</b> Tutor profiles without the icon signify the tutor's disapproval on the posting of session recordings.


          <button className="button mt-3" onClick={() => handleClose()}>Done</button>
        </Modal.Body>
        <span className="buttom-line"></span>
      </Modal>
    </>
  )
}

export default YoutubeConcent
